import { FC, useState, useEffect, useCallback } from 'react';
import { SubscriptionState } from '../../../hooks/App/useSubscription';
import { ExtendData } from '../../../hooks/App/useGetExposeExtendDataFromParent';
import style from './index.module.css';
import { Badge } from '../../common/Badge';
import { Panel, PanelText, PanelTitle } from '../../common/Panel';
import { Button } from '../../common/Button';

export const NextProducts: FC<{
  subscription: SubscriptionState
  extendData: ExtendData | undefined
  add: Function 
}> = ({
  subscription,
  extendData,
  add
}) => {

  const [nextProducts, setNextProducts] = useState<ExtendData["showProducts"]>([]);
  const [showAddPanel, setShowAddPanel] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (!subscription || !extendData) return;
    // 契約中に商品が存在しない場合は、商品追加パネルを表示する
    setShowAddPanel(subscription.subscriptionLines.length === 0);
    // 商品が存在する場合は、テーマカスタマイズから設定された商品情報を表示する
    setNextProducts(extendData.showProducts);
  }, [subscription, extendData]);

  // 追加できる商品は、テーマカスタマイズで指定された１商品のみ
  const handleClickAdd = useCallback(() => {
    if (!extendData) return;
    setDisabled(true);
    const variantId = extendData.contractProduct.variantId;
    const planId = extendData.contractProduct.sellingPlanId;
    const quantity = 1;
    add(planId, variantId, quantity);
  }, [add, extendData]);

  return showAddPanel ? (
    <Panel>
      <PanelTitle>現在お届け予定の商品はありません。</PanelTitle>
      <PanelText>
        <p>
          新定期便サービスセット「グミッツェル for me」の購入を希望される場合、下記の『商品を追加する』ボタンを押下してください。
        </p>
      </PanelText>
      <div style={{ textAlign: 'center', marginTop: 'var(--appGutterEXSmall)' }}>
        <Button disabled={disabled} type="narrow" onClick={handleClickAdd}>商品を追加する</Button>
      </div>
    </Panel>
  ) : (
    <ul className={style.list}>
      {nextProducts.map((product, i) => (
        <li className={style.item} key={i}>
          {product.image && (
            <figure className={style.itemImage}>
              <img src={product.image} alt={product.title || ''}/>
            </figure>
          )}
          <div className={style.itemInfo}>
            {product.type === 'Random' && (
              <Badge color="purple">月替わりでお届けの商品</Badge>
            )}
            {product.type === 'Static' && (
              <Badge color="green">毎月お届けの商品</Badge>
            )}
            <h3>{product.title} × {product.quantity}</h3>
            <div
              dangerouslySetInnerHTML={
                { __html: product.text || '' }
              }
            />
            {nextProducts.length - 1 === i && (
              <p className={style.itemNotice}>
                ※今月の月替わり商品は毎月自動的に変更されます。
              </p>
            )}
          </div>
        </li>
      ))}
    </ul>
  )
}